<template>
  <div v-if="confirmDelete" class="bg-white shadow overflow-hidden rounded-md px-6 py-4">
    <div class="space-y-4">
      <p>Please confirm.</p>

      <div class="space-x-2">
        <BaseButton primary small :disabled="submitting" @click="deleteTask"> Delete </BaseButton>

        <BaseButton ghost small :disabled="submitting" @click="confirmDelete = false">
          Cancel
        </BaseButton>
      </div>
    </div>
  </div>
  <div v-else class="bg-white shadow overflow-hidden rounded-md px-6 py-4" @click="editTask">
    <div class="space-y-4">
      <div class="space-y-2">
        <h5 class="text-sm font-normal">
          {{ task.title }}
        </h5>
        <span
          v-if="isPublished"
          class="text-xs inline-flex px-3 py-1 rounded-full leading-3 text-white bg-gray-600 capitalize"
          >{{ task.status || 'status not set' }}</span
        >
        <span
          v-else
          class="text-xs inline-flex px-3 py-1 rounded-full leading-3 text-white bg-gray-600 capitalize"
          >Draft</span
        >
      </div>

      <ul class="flex space-x-2">
        <li v-if="task.content" class="relative">
          <span class="inline-block p-2 bg-gray-200 text-gray-800 rounded-full leading-none">
            <svg
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              stroke="currentColor"
              viewBox="0 0 24 24"
              class="w-4 h-4 inline-flex focus:outline-none"
              v-tip="{ content: 'Requirements' }"
            >
              <path d="M4 6h16M4 12h16M4 18h7" />
            </svg>
          </span>
        </li>
        <li v-if="task.linksCount" class="relative">
          <span class="inline-block p-2 bg-gray-200 text-gray-800 rounded-full leading-none">
            <svg
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              stroke="currentColor"
              viewBox="0 0 24 24"
              class="w-4 h-4 inline-flex focus:outline-none"
              v-tip="{ content: 'Links' }"
            >
              <path
                d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656
                5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4
                4 0 00-5.656-5.656l-1.1 1.1"
              />
            </svg>
          </span>
        </li>
        <li v-if="task.mediaCount" class="relative">
          <span class="inline-block p-2 bg-gray-200 text-gray-800 rounded-full leading-none">
            <svg
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              stroke="currentColor"
              viewBox="0 0 24 24"
              class="w-4 h-4 inline-flex focus:outline-none"
              v-tip="{ content: 'Attachments' }"
            >
              <path
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4
                4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              />
            </svg>
          </span>
        </li>
        <li v-if="task.notesCount" class="relative">
          <span class="inline-block p-2 bg-gray-200 text-gray-800 rounded-full leading-none">
            <svg
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              stroke="currentColor"
              viewBox="0 0 24 24"
              class="w-4 h-4 inline-flex focus:outline-none"
              v-tip="{ content: 'Notes' }"
            >
              <path
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1
                1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </span>
        </li>
      </ul>

      <span class="inline-block">
        Assigned to: {{ userAssigned ? userAssigned.fullName : 'unassigned' }}
      </span>

      <div v-if="$membershipHasPermissionTo('delete tasks')" class="space-x-2">
        <BaseButton ghost small @click.stop="confirmDelete = true"> Delete </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      confirmDelete: false,
      submitting: false,
    };
  },
  computed: {
    userAssigned() {
      if (!this.task.userAssignedId) return null;

      return this.$store.state.entities.users.byId[this.task.userAssignedId];
    },
    isPublished() {
      return typeof this.task.publishedAt === 'string';
    },
  },
  methods: {
    editTask() {
      this.$modal.show({
        component: () => import('@/components/Tasks/TaskModal.vue'),
        props: {
          taskId: this.task.uuid,
        },
        on: {
          'status-updated': () => {
            this.$emit('updated', this.task.uuid);
          },
        },
        hideEvent: 'task-modal:closed',
      });
    },
    async deleteTask() {
      this.submitting = true;

      try {
        await this.$store.dispatch({
          type: 'ui/projectTasks/destroy',
          projectId: this.task.projectId,
          taskId: this.task.uuid,
        });
      } catch (error) {
        this.submitting = false;
      }
    },
  },
};
</script>
